<template>
  <div>
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Create the tabs -->

      <div class="tab-content">
        <!-- Home tab content -->
        <div class="tab-pane" id="control-sidebar-home-tab">


          <!-- /.control-sidebar-menu -->

        </div>

        <!-- /.tab-pane -->
      </div>
    </aside>
    <!-- /.control-sidebar -->
    <!-- Add the sidebar's background. This div must be placed
         immediately after the control sidebar -->
    <div class="control-sidebar-bg"></div>
  </div>
</template>

<script>
  export default {
    name: 'ControlSidebar'
  }
</script>



// WEBPACK FOOTER //
// ControlSidebar.vue?ad61f720